import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function AboutSection() {
  return <section id="nosotros" className="py-24 bg-white relative overflow-hidden" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-21">
          <h2 className="text-lg font-bold text-zumpago-red tracking-wider uppercase mb-3" data-id="element-22">
            ¿Quiénes Somos?
          </h2>
          <h3 className="text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-23">
            Revolucionando el ecosistema de las recaudaciones
          </h3>
          <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-24">
            En ZUMPAGO, somos más que un proveedor de tecnología de pagos y
            cobranza, somos un facilitador de soluciones que simplifica tus
            procesos operativos de recaudación.
          </p>

          {/* Nuestra Historia */}
          <div className="mt-12 bg-gray-50 border border-gray-100 rounded-3xl p-8 md:p-12" data-id="element-25">
            <div className="flex items-center gap-4 mb-6" data-id="element-26">
              <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-27">
                <BookOpen className="w-6 h-6 text-zumpago-red" data-id="element-28" />
              </div>
              <h4 className="text-2xl font-bold text-gray-900" data-id="element-29">
                Nuestra Historia
              </h4>
            </div>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-30">
              ZUMPAGO es una empresa de capitales privados que cuenta con un
              equipo de profesionales altamente calificado en tecnologías
              financieras (Fintech). Comienza su operación y atención a público
              en Santiago de Chile el año 2015 a través de la habilitación de su
              primer canal de atención, buscando ser una nueva alternativa en el
              mundo de la recaudación, pago de cuentas de servicios, recargas de
              productos prepago, entre otros servicios transaccionales, con un
              alcance regional, donde ya cuenta con operaciones en Argentina,
              Chile, Ecuador y Perú, ofreciendo herramientas tecnológicas
              transaccionales de última generación, seguras y de fácil uso.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-31">
              Actualmente contamos con una amplia gama de productos y soluciones
              transversales que permiten a los comercios, empresas e
              instituciones de distinto tamaño mejorar los procesos operativos y
              comerciales de pago, brindando una mejor experiencia de pago para
              los clientes finales.
            </p>
          </div>

          {/* Nuestra Oferta de Valor */}
          <div className="mt-12 bg-white border border-gray-100 rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-32">
            <div className="flex items-center gap-4 mb-8" data-id="element-33">
              <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-34">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-zumpago-red" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-35">
                  <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" data-id="element-36" />
                </svg>
              </div>
              <h4 className="text-2xl font-bold text-gray-900" data-id="element-37">
                Nuestra Oferta de Valor
              </h4>
            </div>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-38">
              <div className="p-6 bg-gray-50 rounded-2xl" data-id="element-39">
                <h5 className="font-bold text-gray-900 mb-2" data-id="element-40">
                  Proveedor Neutro
                </h5>
                <p className="text-gray-600 leading-relaxed" data-id="element-41">
                  Podemos atender a cualquier cliente, marca o industria
                  ofreciendo condiciones no discriminatorias entre un cliente y
                  otro.
                </p>
              </div>
              <div className="p-6 bg-gray-50 rounded-2xl" data-id="element-42">
                <h5 className="font-bold text-gray-900 mb-2" data-id="element-43">Experiencia</h5>
                <p className="text-gray-600 leading-relaxed" data-id="element-44">
                  Equipo de profesionales que cuentan con habilidad técnica
                  probada y amplio conocimiento en cada etapa del proceso de
                  recaudación.
                </p>
              </div>
              <div className="p-6 bg-gray-50 rounded-2xl" data-id="element-45">
                <h5 className="font-bold text-gray-900 mb-2" data-id="element-46">Adaptabilidad</h5>
                <p className="text-gray-600 leading-relaxed" data-id="element-47">
                  Estructura interna capaz de atender a empresas de diferente
                  tamaño y complejidad.
                </p>
              </div>
              <div className="p-6 bg-gray-50 rounded-2xl" data-id="element-48">
                <h5 className="font-bold text-gray-900 mb-2" data-id="element-49">Cobertura</h5>
                <p className="text-gray-600 leading-relaxed" data-id="element-50">
                  Proveemos diversos canales de atención para usuarios finales:
                  Portales Web, APPs, Kioscos Autoatención, Red de Terminales de
                  Punto de Venta (PoS) y Oficinas de Atención al Público.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}